
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {},
  filters: {},
})
export default class RnaSeqLaunch extends Vue {
  @Prop({ type: String, default: "/run/nf-core-rnaseq" })
  routeTo: string;
}
